import React from 'react';
import { IActivityEntityBase } from '.';
import { parseActivityHTML } from '@utils/activity-utils';

interface IActivityTemplate {
  activity: IActivityEntityBase;
}

const ActivityTemplate: React.FC<IActivityTemplate> = ({ activity }) => {
  const body = parseActivityHTML(activity);

  return <div dangerouslySetInnerHTML={{ __html: body }} />;
};

export default ActivityTemplate;
